import BarChartCustom from "@components/BarChart";
import NoData from "@components/NoData";
import { useIoCContext } from "@context/IoCContext/IoCContext";
import { Types } from "@ioc/types";
import { CircularProgress, Grid } from "@material-ui/core";
import { IChartDataService } from "@modules/financial/models/IChartDataService";
import { useFinancialDashboardContext } from "@pages/Financial/FinancialDashboard/FinancialDashboardContext";
import { IFinancialDashboardChartQuery } from "@pages/Financial/FinancialInstallments/interface";
import { formatCurrency, formatDecimal } from "@utils/index";
import { useSnackbar } from "notistack";
import React, { useCallback, useEffect, useState } from "react";

const ManagerChart: React.FC<{
  filters: IFinancialDashboardChartQuery;
}> = ({ filters }) => {
  const iocContext = useIoCContext();

  const getChartService = iocContext.serviceContainer.get<IChartDataService>(
    Types.Financial.IChartDataService
  );

  const [series, setSeries] = useState<
    ApexAxisChartSeries | ApexNonAxisChartSeries
  >([-1]);

  const { query, loaders, setLoaders } = useFinancialDashboardContext();
  const { enqueueSnackbar } = useSnackbar();

  const getManagerChart = useCallback(async () => {
    try {
      setLoaders((state) => ({
        ...state,
        isManagerChartLoading: true,
      }));
      const queryResult = await getChartService.getMangerChart({
        ...filters,
        from: query.from,
        to: query.to,
      });

      let data = queryResult.rows
        .filter((item) => item.every((value) => value != null))
        .map((item) => {
          let xList = item[1]?.split(" ") ?? [];
          return {
            x: xList.slice(0, 1),
            y: item[2],
          };
        });

      setSeries([{ data }]);
    } catch (error) {
      enqueueSnackbar("Ocorreu um erro ao carregar gráfico do gerente!", {
        variant: "error",
      });
    } finally {
      setLoaders((state) => ({
        ...state,
        isManagerChartLoading: false,
      }));
      setLoaders((state) => ({
        ...state,
        isFirstLoading: false,
      }));
    }
  }, [
    enqueueSnackbar,
    filters,
    setLoaders,
    getChartService,
    query.from,
    query.to,
  ]);

  useEffect(() => {
    getManagerChart();
  }, [getManagerChart]);

  return series.length && series[0] === -1 ? (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{ height: "100%" }}
    >
      <CircularProgress color="primary" />
    </Grid>
  ) : series.length > 0 ? (
    <BarChartCustom
      series={series}
      yType="Reais"
      yFormatter={(value) => formatDecimal(value)}
      labelFormatter={(value) => formatCurrency(value)}
      isLoading={loaders.isManagerChartLoading}
    />
  ) : (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{ height: "100%" }}
    >
      <NoData>Nada encontrado</NoData>
    </Grid>
  );
};

export default ManagerChart;
